/**
 * QS-based embedded session init was removed when the resolve-admin payload
 * switched to buildingDetails (an array), which cannot be expressed as URL
 * query parameters. Authentication now happens exclusively via postMessage
 * through VendorLoginPage.
 */
export const useEmbeddedSessionInit = () => {
  return { isInitializing: false };
};
